import template from "./verpackung-checker-recyclable-rule.html.twig";

Packlab.Component.register('verpackung-checker-recyclable-rule', {
    template,

    props: {
        rule: {
            type: Object,
            required: true
        }
    }
});
